import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { MapContainerComponent } from "@hermes/aphrodite/map";
import {
    svgCross,
    SvgIconComponent,
    svgListView,
    svgMapView,
    SvgRegistryService,
} from "@hermes/aphrodite/svg";
import {
    TabItemComponent,
    TabListComponent,
    TabTitleDirective,
} from "@hermes/aphrodite/tab";
import { PlacesSearchBarModule } from "@hermes/fragments/places-search-bar";
import { ShopModule } from "@hermes/fragments/shop";
import { LoadGeoLibrariesServiceModule } from "@hermes/map-utils";
import { ShopLocatorStateModule } from "@hermes/states/shop-locator";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

import { ShopLocatorMapComponent } from "./shop-locator-map/shop-locator-map.component";
import { ShopLocatorMapItemComponent } from "./shop-locator-map-item/shop-locator-map-item.component";
import { ShopLocatorSearchComponent } from "./shop-locator-search/shop-locator-search.component";
import { ShopLocatorSearchLocationComponent } from "./shop-locator-search-location/shop-locator-search-location.component";

@NgModule({
    declarations: [
        ShopLocatorMapComponent,
        ShopLocatorSearchLocationComponent,
        ShopLocatorSearchComponent,
        ShopLocatorMapItemComponent,
    ],
    exports: [
        ShopLocatorMapComponent,
        ShopLocatorSearchLocationComponent,
        ShopLocatorSearchComponent,
        ShopLocatorMapItemComponent,
    ],
    imports: [
        CommonModule,
        MapContainerComponent,
        PlacesSearchBarModule,
        ShopModule,
        LoadGeoLibrariesServiceModule,
        TabListComponent,
        TabItemComponent,
        TabTitleDirective,
        ShopLocatorStateModule,
        PlacesSearchBarModule,
        SrOnlyNoSnippetDirective,
        SvgIconComponent,
    ],
})
export class ShopLocatorModule {
    constructor(svgRegistryService: SvgRegistryService) {
        svgRegistryService.registerSvgs([svgCross, svgListView, svgMapView]);
    }
}
